import { oc } from 'ts-optchain';
import _ from 'lodash';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';

let existing: Dictionary<number[]> | undefined = {};
export const serverIdToPartyIdsSelector = createDeepEqualSelector(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  (state: StoreType) => oc(state).service.app.app.serverIdToPartyIds()!,
  (serverIdToPartyIds: Dictionary<number[]>): Dictionary<number[]> => {
    if (serverIdToPartyIds && existing) {
      _.forEach(serverIdToPartyIds, (entry, key) => {
        if (existing && existing[key] && _.isEqual(entry, existing[key])) {
          serverIdToPartyIds[key] = existing[key];
        }
      });
    }
    existing = serverIdToPartyIds;
    return serverIdToPartyIds;
  }
);
